// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cfe6ba35","455":"45c5607e"}[chunkId] + ".chunk.js";
};